var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 32.0509C38 35.3365 35.3365 38 32.0509 38H5.94912C2.6635 38 0 35.3365 0 32.0509V8L8 0H32.0509C35.3365 0 38 2.6635 38 5.94912V32.0509Z",
    fill: "#B33939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H5.33338C6.8 8 8 6.82046 8 5.35385V0L0 8Z",
    fill: "#E89989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59363 24.464V14H9.88963C10.4656 14 10.999 14.0533 11.4896 14.16C11.991 14.2667 12.423 14.448 12.7856 14.704C13.1483 14.96 13.431 15.296 13.6336 15.712C13.8363 16.1173 13.9376 16.624 13.9376 17.232C13.9376 17.808 13.8363 18.3093 13.6336 18.736C13.431 19.1627 13.1483 19.52 12.7856 19.808C12.4336 20.0853 12.0123 20.2933 11.5216 20.432C11.0416 20.56 10.519 20.624 9.95363 20.624H8.44963V24.464H6.59363ZM8.44963 19.136H9.80963C11.3456 19.136 12.1136 18.5013 12.1136 17.232C12.1136 16.5707 11.911 16.1173 11.5056 15.872C11.111 15.616 10.5243 15.488 9.74563 15.488H8.44963V19.136Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9061 24.464V14H18.7061C20.3061 14 21.5541 14.432 22.4501 15.296C23.3461 16.16 23.7941 17.456 23.7941 19.184C23.7941 20.048 23.6768 20.8107 23.4421 21.472C23.2181 22.1333 22.8875 22.688 22.4501 23.136C22.0235 23.5733 21.5008 23.904 20.8821 24.128C20.2741 24.352 19.5808 24.464 18.8021 24.464H15.9061ZM17.7621 22.96H18.5781C19.6448 22.96 20.4608 22.656 21.0261 22.048C21.6021 21.4293 21.8901 20.4747 21.8901 19.184C21.8901 17.904 21.6021 16.9707 21.0261 16.384C20.4501 15.7973 19.6341 15.504 18.5781 15.504H17.7621V22.96Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9061 24.464V14H32.2261V15.568H27.7621V18.528H31.5701V20.096H27.7621V24.464H25.9061Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfTip);
export default __webpack_public_path__ + "static/media/pdf_tip.90e51a7d.svg";
export { ForwardRef as ReactComponent };